import createTableStore from "ds/components/Table/store/useTableStore";

import { SESSIONS_COLUMN_CONFIG, SESSIONS_COLUMNS_STORAGE_KEY } from "./constants";

const useSessionsTableStore = createTableStore({
  storageKey: SESSIONS_COLUMNS_STORAGE_KEY,
  config: SESSIONS_COLUMN_CONFIG,
});

export default useSessionsTableStore;
